import { Images } from '@/assets/imgs';
import { ObserverContainer } from '@/components/ObserverContainer';
import { splitLines } from '@/modules/utils';
import Image from 'next/image';
import { useEffect, useRef } from 'react';
import { NextGenGamingBubbles } from './Bubbles';
import { NextGenGamingTokens } from './Tokens';
import { LinkButton } from '@/components/Buttons';

export const NextGenGamingNoTitle = () => {
  const ref = useRef<HTMLHeadingElement>(null);

  useEffect(() => {
    if (ref.current) {
      splitLines(ref.current);
    }
  }, []);

  return (
    <div className="token-sale-nextgen-main-container">
      <div className="xbg-next-gen-gaming">
        <div className="container"></div>

        <div className="background-container">
          <Image
            className="background"
            alt=""
            quality={100}
            width={2828}
            height={1736}
            src={Images.landing.nextgen_gaming_bg}
          />

          <ObserverContainer className="main-bubble">
            <Image
              src={Images.tokenSale.logo}
              alt=""
              width={147}
              height={153}
            />
          </ObserverContainer>

          <div className="orbit-identifier second">
            <h3>Gaming Application layer</h3>
            <div className="line">
              <div className="circle"></div>
            </div>

            <div className="sub">
              <Image
                src={Images.tokenSale.arbitium}
                alt="subnet"
                width={25}
                height={25}
                quality={100}
              />
              <Image
                src={Images.tokenSale.sui}
                alt="subnet"
                width={25}
                height={25}
                quality={100}
              />
              <Image
                src={Images.tokenSale.subnet}
                alt="subnet"
                width={25}
                height={25}
                quality={100}
              />
              <div>Multichain</div>
            </div>
          </div>

          <div className="orbit-identifier first">
            <h3>GAMING IDENTITY LAYER</h3>
            <div className="line">
              <div className="circle"></div>
            </div>

            <div className="sub">
              <Image
                src={Images.tokenSale.subnet}
                alt="subnet"
                width={25}
                height={25}
                quality={100}
              />
              <div>Subnet</div>
            </div>
          </div>

          <div className="orbit2 flex column">
            <ObserverContainer className="orbit2-content flex expand">
              <div className="gamerbase-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <span className="lexend-body-sxl sphere-title">
                  Tournament Platform
                  <br /> <span className="circle circle-yellow"></span> Planning
                </span>
              </div>

              <div className="launchpad-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <span className="lexend-body-sxl sphere-title">
                  Gaming Launchpad
                  <br /> <span className="circle circle-green"></span> Live
                </span>
              </div>

              <div className="social-reputation">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <div className="lexend-body-sxl sphere-title">
                  <div className="flex middle">
                    <Image
                      className="gbase"
                      src={Images.tokenSale.gamerbase}
                      alt=""
                      width={32}
                      height={32}
                    />
                    <div>
                      GamerBase
                      <br />
                      <div className="flex middle">
                        <span className="circle circle-green"></span> Live
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="xborgid-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <div className="lexend-body-sxl sphere-title">
                  AI Companion App
                  <br /> <span className="circle circle-yellow"></span> Planning
                </div>
              </div>
            </ObserverContainer>
          </div>
          <div className="orbit flex column">
            <ObserverContainer className="orbit-content flex expand">
              <div className="gamerbase-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <span className="lexend-body-sxl sphere-title">
                  Tournament <br /> History
                </span>
              </div>

              <div className="launchpad-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <span className="lexend-body-sxl sphere-title">
                  Gaming Data
                </span>
              </div>

              <div className="social-reputation">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <div className="lexend-body-sxl sphere-title">
                  Social <br /> Reputation
                </div>
              </div>

              <div className="xborgid-sphere">
                <Image
                  src={Images.tokenSale.sphere}
                  alt=""
                  width={45}
                  height={45}
                />

                <div className="lexend-body-sxl sphere-title">
                  Sign in with
                  <Image
                    className="xborgid"
                    src={Images.tokenSale.xborgid}
                    alt="xborg"
                    width={144}
                    height={48}
                  />
                </div>
              </div>
            </ObserverContainer>
          </div>
        </div>

        <NextGenGamingBubbles />
        <NextGenGamingTokens />
      </div>
    </div>
  );
};
